import API from "./api"

export default function useGoogleMaps() {
  async function placeDetails(place_id) {
    return await API.get(`/google_maps/place_details/${place_id}`)
  }

  async function reverseGeocode({ latitude, longitude }) {
    return await API.get("/google_maps/reverse_geocode", {
      lat: latitude,
      lng: longitude,
    })
  }

  return { placeDetails, reverseGeocode }
}
